module.exports = __webpack_public_path__ + "img/follow-goal.40f8b90c.svg";